export function *findInPropertyPath( source, property, predicate ) {
    if ( predicate( source ) ) {
      yield source;
    }
    for ( let child of source[property] ) {
      let result = findInPropertyPath( child, property, predicate ).firstOrDefault();
      if ( result ) {
        yield result;
      }
    }
  }